import { gql } from "@apollo/client";

export const MAGAZINE = gql`
    query Magazine($first: Int = 0, $skip: Int!, $createdUtc: OrderByDirection = DESC, $status: Status!, $culture: String!, $displayText_contains: String = "") {
        magazine (
        first: $first,
        skip: $skip,
        orderBy: {createdUtc: $createdUtc},
        where: {localization: {culture: $culture}, displayText_contains: $displayText_contains},
        status: $status
        ) {
            displayText
            pages
            summary
            createdUtc
            cover {
                paths(first: 1)
            }
            highlights {
                paths
            }
            file {
                paths
            }
        }
    }
`;

export const MAGAZINE_MEDIA_VOLUME = gql`
    query MagazineMediaVolume {
        mediaAssets(includeSubDirectories: true, path: "magazine/pdf") {
        path
        length
        name
        }
    }
`;